
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import NotFound from '../pages/NotFound';

const HomePage = lazy(() => import('../pages/home/page'));
const ThanksPage = lazy(() => import('../pages/thanks/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const IntegrationsPage = lazy(() => import('../pages/integrations/page'));
const BlogPage = lazy(() => import('../pages/blog/page'));
const EcommercePage = lazy(() => import('../pages/industry/ecommerce'));
const SubscriptionsPage = lazy(() => import('../pages/industry/subscriptions'));
const PrivacyPolicyPage = lazy(() => import('../pages/legal/privacy-policy'));
const TermsPage = lazy(() => import('../pages/legal/terms-of-service'));
const DpaPage = lazy(() => import('../pages/legal/dpa'));
const CookiePolicyPage = lazy(() => import('../pages/legal/cookie-policy'));
const AcceptableUsePolicyPage = lazy(() => import('../pages/legal/acceptable-use-policy'));
const SecurityPage = lazy(() => import('../pages/legal/security'));
const BinLookupPage = lazy(() => import('../pages/tools/bin-lookup'));
const DeclineCodesPage = lazy(() => import('../pages/tools/decline-codes'));
const PmCardsPage = lazy(() => import('../pages/solutions/payment-method/cards'));
const PmDirectDebitPage = lazy(() => import('../pages/solutions/payment-method/direct-debit'));
const PmDigitalWalletsPage = lazy(() => import('../pages/solutions/payment-method/digital-wallets'));
const PmPaypalPage = lazy(() => import('../pages/solutions/payment-method/paypal'));
const FrInsufficientFundsPage = lazy(() => import('../pages/solutions/failure-reason/insufficient-funds'));
const FrSoftDeclinesPage = lazy(() => import('../pages/solutions/failure-reason/soft-declines'));
const FrHardDeclinesPage = lazy(() => import('../pages/solutions/failure-reason/hard-declines'));
const FrDoNotHonorPage = lazy(() => import('../pages/solutions/failure-reason/do-not-honor'));
const FrExpiredCardsPage = lazy(() => import('../pages/solutions/failure-reason/expired-cards'));

// ── DORMANT pages - accessible by direct URL only.
// NOT linked from the public navbar. NOT registered in scripts/generate-static-routes.mjs
// (so no SEO HTML, no sitemap entry, no Google indexing). Soft launch later.
const EvaluationPage = lazy(() => import('../pages/evaluation/page'));
const CompareSlickerPage = lazy(() => import('../pages/compare/slicker'));
const CompareStripeSmartRetriesPage = lazy(() => import('../pages/compare/stripe-smart-retries'));
const CompareChargebeeSmartDunningPage = lazy(() => import('../pages/compare/chargebee-smart-dunning'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/thanks',
    element: <ThanksPage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/integrations',
    element: <IntegrationsPage />,
  },
  {
    path: '/blog',
    element: <BlogPage />,
  },
  {
    path: '/industry/e-commerce',
    element: <EcommercePage />,
  },
  {
    path: '/industry/subscriptions',
    element: <SubscriptionsPage />,
  },
  {
    path: '/privacy-policy',
    element: <PrivacyPolicyPage />,
  },
  {
    path: '/terms-of-service',
    element: <TermsPage />,
  },
  {
    path: '/dpa',
    element: <DpaPage />,
  },
  {
    path: '/cookie-policy',
    element: <CookiePolicyPage />,
  },
  {
    path: '/acceptable-use-policy',
    element: <AcceptableUsePolicyPage />,
  },
  {
    path: '/security',
    element: <SecurityPage />,
  },
  {
    path: '/tools/bin-lookup',
    element: <BinLookupPage />,
  },
  {
    path: '/tools/decline-codes',
    element: <DeclineCodesPage />,
  },
  {
    path: '/solutions/payment-method/cards',
    element: <PmCardsPage />,
  },
  {
    path: '/solutions/payment-method/direct-debit',
    element: <PmDirectDebitPage />,
  },
  {
    path: '/solutions/payment-method/digital-wallets',
    element: <PmDigitalWalletsPage />,
  },
  {
    path: '/solutions/payment-method/paypal',
    element: <PmPaypalPage />,
  },
  {
    path: '/solutions/failure-reason/insufficient-funds',
    element: <FrInsufficientFundsPage />,
  },
  {
    path: '/solutions/failure-reason/soft-declines',
    element: <FrSoftDeclinesPage />,
  },
  {
    path: '/solutions/failure-reason/hard-declines',
    element: <FrHardDeclinesPage />,
  },
  {
    path: '/solutions/failure-reason/do-not-honor',
    element: <FrDoNotHonorPage />,
  },
  {
    path: '/solutions/failure-reason/expired-cards',
    element: <FrExpiredCardsPage />,
  },

  // DORMANT - direct-URL access only, not in nav, not in static SEO
  {
    path: '/evaluation',
    element: <EvaluationPage />,
  },
  {
    path: '/compare/slicker',
    element: <CompareSlickerPage />,
  },
  {
    path: '/compare/stripe-smart-retries',
    element: <CompareStripeSmartRetriesPage />,
  },
  {
    path: '/compare/chargebee-smart-dunning',
    element: <CompareChargebeeSmartDunningPage />,
  },

  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
